import * as React from "react"
import { useState, useEffect } from "react";
import { Grid, Box, Typography, Link } from "@mui/material";

const item = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    m: 5,
    py: 4,
    boxShadow: 5,
    borderRadius: 2,
    textDecoration: 'none'
};
//https://drive.google.com/file/d/{id}


async function fetchFilesJSON() {
    const response = await fetch(`https://www.googleapis.com/drive/v3/files?q=%271NMY7Z2Se5G8aC7k864-n3s24WfnCSHix%27%20in%20parents&key=${process.env.REACT_APP_DRIVE_API_KEY}`);
    const files = await response.json();
    return files;
}
  
const Miscellaneous = () => {
    // const dummyData = [{name: 'Sample Paper 1', id: 'id1'}, {name: 'Sample Paper 2', id: 'id2'}];
    const [files, setfiles] = useState([]);
    useEffect(() => {
        fetchFilesJSON().then((filesData) => {
            setfiles(filesData['files']);
        })     
    }, [])
    return (
    <>
    <Typography component="h1" align="center" sx={{mt: 5}} variant="overline">
        Miscellaneous Papers
    </Typography>
    <Grid container spacing={5}>
       {files.map((obj, i) => (
            <Grid key={i} item xs={12} md={4}>
                <Box sx={item} component={Link} href={`https://drive.google.com/file/d/${obj.id}`}>
                    <Box
                    component="img"
                    src="/open-book.png"
                    alt="books"
                    sx={{ height: 55 }}
                    />
                    <Typography variant="h6" sx={{ mt: 5 }}>
                        {obj.name}
                    </Typography>
                </Box>
            </Grid>
        ))}
        </Grid>
    </>
    )
};

export default Miscellaneous;